import { useMemo } from 'react';
import { normalizeLinkedinIntegration } from '../helpers/integrationAdapters';

export const ROLE_OPTIONS = [
  { label: 'Any role', value: '' },
  { label: 'Admin', value: 'network_admin' },
  { label: 'Ally', value: 'ally' },
];

export const CONTACTS_OPTIONS = [
  { label: 'Any sharing status', value: '' },
  { label: 'Sharing', value: 'sharing' },
  { label: 'Not sharing', value: 'not_sharing' },
];

// Values map to `admin.onboardingCompleted`.
export const INVITE_STATUS_OPTIONS = [
  { label: 'Any invite status', value: '' },
  { label: 'Accepted', value: 'accepted' },
  { label: 'Pending', value: 'pending' },
];

// Values map to `normalizeLinkedinIntegration(...).iconState`, which has exactly
// these four states.
export const LINKEDIN_OPTIONS = [
  { label: 'Any LinkedIn status', value: '' },
  { label: 'LinkedIn active', value: 'active' },
  { label: 'LinkedIn paused', value: 'paused' },
  { label: 'LinkedIn not connected', value: 'disabled' },
  { label: 'LinkedIn action needed', value: 'warning' },
];

export const EMPTY_FILTERS = {
  search: '',
  inviteStatus: '',
  role: '',
  contactsShared: '',
  linkedin: '',
};

const matchesSearch = (admin, search) => {
  const term = search.trim().toLowerCase();
  if (!term) return true;
  const name = (admin.name || '').toLowerCase();
  const email = (admin.email || '').toLowerCase();
  return name.includes(term) || email.includes(term);
};

const matchesContacts = (admin, value) => {
  if (!value) return true;
  const isSharing = !!admin.shareContacts;
  return value === 'sharing' ? isSharing : !isSharing;
};

const matchesInviteStatus = (admin, value) => {
  if (!value) return true;
  const isAccepted = !!admin.onboardingCompleted;
  return value === 'accepted' ? isAccepted : !isAccepted;
};

export const filterAdmins = (admins, filters) =>
  admins.filter((admin) => {
    if (!matchesSearch(admin, filters.search)) return false;
    if (!matchesInviteStatus(admin, filters.inviteStatus)) return false;
    if (filters.role && admin.role !== filters.role) return false;
    if (!matchesContacts(admin, filters.contactsShared)) return false;
    if (filters.linkedin && normalizeLinkedinIntegration(admin).iconState !== filters.linkedin) return false;
    return true;
  });

export const useFilteredAdmins = (admins, filters) => useMemo(() => filterAdmins(admins, filters), [admins, filters]);
